<template>
  <v-container grid-list-xl>
    <v-layout
      row
      wrap
    >
      <v-flex
        lg12
        sm12
        xs12
      >
        <Search />
        <v-btn
          depressed
          color="success"
          class="mb-3"
        >
          <router-link
            :to="{name: 'dashboard-usuarios-novo'}"
            class="white--text"
            title="Adicionar"
          >
            <v-icon>add</v-icon>Novo
          </router-link>
        </v-btn>
        <v-data-table
          class="elevation-0"
          :headers="table.header"
          :items="table.content"
          :item-key="'id'"
          :loading="table.isLoading"
          :items-per-page="table.paginate.inputPage.size"
          :options.sync="pagination"
          :server-items-length="table.total"
          :footer-props="{ 'items-per-page-options': [10, 20, 30, 40, 50, 100],showFirstLastPage: true, showCurrentPage: true }"
          @click:row="goToForm"
        >
          <template v-slot:item.active="{ item }">
            <v-chip
              :color="item.active ? 'success':'warning'"
              small
            >
              {{ item.active ? 'Ativo':'Invativo' }}
            </v-chip>
          </template>
          <template v-slot:item.profile="{ item }">
            {{ item.profile.name }}
          </template>
          <template v-slot:item.actions="{ item }">
            <router-link
              :to="{ name: 'dashboard-usuarios-editar', params: { id: item.id } }"
              title="Visualizar"
            >
              <v-icon>visibility</v-icon>
            </router-link>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import Search from './Search';

  export default {
    components: {
      Search
    },
    data: () => ({
      pagination: null
    }),
    computed: {
      ...mapState('usuario', ['table'])
    },
    watch: {
      pagination: {
        handler() {
          this.changePagination();
        },
        deep: true
      }
    },
    destroyed() {
      this.clear();
    },
    methods: {
      changePagination() {
        const { page, itemsPerPage } = this.pagination;
        const paginate = {
          ...this.table.paginate,
          inputPage: {
            page: page,
            per_page: itemsPerPage,
            sort: 'id:desc'
          }
        };
        this.changePage(paginate);
        this.search();
      },
      goToForm({ id }) {
        this.$router.push({
          name: 'dashboard-usuarios-editar',
          params: { id }
        });
      },
      ...mapActions('usuario', { search: 'SEARCH' }),
      ...mapActions('usuario', { clear: 'CLEAR' }),
      ...mapActions('usuario', { changePage: 'CHANGE_PAGE' })
    },
  };
</script>
